import { EFinancingProductId } from '@/types'

export const MFO_PRODUCTS: EFinancingProductId[] = [EFinancingProductId.EXPRESS_MFO, EFinancingProductId.BNPL_POLECREDIT]
